import {useHandleSignInCallback} from '@logto/react';
import {useEffect} from "react";

export const Callback = (props) => {
    const nowHash = props.nowHash
    const {isLoading} = useHandleSignInCallback(() => {
        // Navigate to root path when finished
        window.location.replace('/' + nowHash)
    });

    // When it's working in progress
    if (isLoading) {
        return <div>Redirecting...</div>;
    }
};
